
import Vue from "vue";
import { LOYALTY_ROUTE_NAMES } from "@/loyalty-routes";
import { accountOfferAccess } from "@/helpers/loyaltyEditAccess";

export default Vue.extend({
  computed: {
    hasEditAccess() {
      return accountOfferAccess();
    }
  },
  data() {
    return {
      accountOffersRoute: LOYALTY_ROUTE_NAMES.ACCOUNT_OFFERS_DETAILS
    };
  },
  methods: {
    onItemClick(item: any) {
      this.$router.push({
        name: this.accountOffersRoute,
        params: { id: item.accountNumber }
      });
    }
  }
});
